//#region Imports

import { InjectionToken } from '@angular/core';

import { HttpAsyncConfig } from './http-async.config';

//#endregion

export const HTTP_ASYNC_CONFIG: InjectionToken<HttpAsyncConfig> = new InjectionToken('HTTP_ASYNC_CONFIG');
